<template>
  <section class="dashboard-parcerias">
    <!-- VISÃO 1: GERENCIAMENTO DE PARCERIAS POR AÇÃO (EMBUTIDO NA ÁREA DE PARCERIAS) -->
    <GerenciadorParceriasAcaoModal v-if="modalGerenciadorAberto" @fechar="fecharGerenciadorAcoes" />

    <!-- VISÃO 2: DASHBOARD PADRÃO (ANÁLISE DE PARCERIAS) -->
    <div v-else class="painel-dashboard-parcerias">
      <header class="dashboard-header">
        <div>
          <h2>Análise de parcerias</h2>
          <p>
            Acompanhe as solicitações de parceria, consulte seus status e registre as decisões da PREX.
          </p>
        </div>

        <button type="button" class="btn-gerenciar-parcerias-acao" id="btn-gerenciar-parcerias-acao"
          aria-label="Gerenciar parcerias por ação" @click="abrirGerenciadorAcoes">
          <i class="fa-solid fa-handshake-angle" aria-hidden="true"></i>
          <span>Gerenciar parcerias por ação</span>
        </button>
      </header>

      <div v-if="feedback.texto" class="feedback" :class="feedback.tipo">
        {{ feedback.texto }}

        <button type="button" aria-label="Fechar mensagem" @click="limparFeedback">
          ×
        </button>
      </div>

      <div class="cards-resumo" aria-label="Resumo das solicitações">

        <button type="button" class="card-resumo total" :class="{ selecionado: !filtros.status }"
          @click="selecionarStatus('')">
          <span class="rotulo">
            Total recebido
          </span>

          <strong>
            {{ resumo.total }}
          </strong>

          <small>
            Todas as solicitações
          </small>
        </button>


        <button type="button" class="card-resumo pendente" :class="{
          selecionado:
            filtros.status === STATUS_PARCERIA.FORMULARIO_RECEBIDO
        }" @click="
          selecionarStatus(
            STATUS_PARCERIA.FORMULARIO_RECEBIDO
          )
          ">
          <span class="rotulo">
            Aguardando análise
          </span>

          <strong>
            {{ resumo.pendentes }}
          </strong>

          <small>
            Requerem uma decisão
          </small>
        </button>

        <button type="button" class="card-resumo analise" :class="{
          selecionado:
            filtros.status === STATUS_PARCERIA.EM_ANALISE
        }" @click="
          selecionarStatus(
            STATUS_PARCERIA.EM_ANALISE
          )
          ">
          <span class="rotulo">
            Em análise
          </span>

          <strong>
            {{ resumo.emAnalise }}
          </strong>

          <small>
            Em avaliação pela PREX
          </small>
        </button>

        <button type="button" class="card-resumo aguardando-articulacao" :class="{
          selecionado:
            filtros.status === STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO
        }" @click="
          selecionarStatus(
            STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO
          )
          ">
          <span class="rotulo">
            Em processo de articulação
          </span>

          <strong>
            {{ resumo.emArticulacao }}
          </strong>

          <small>
            Processo em andamento
          </small>
        </button>


        <button type="button" class="card-resumo aguardando-reitoria" :class="{
          selecionado:
            filtros.status === STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA
        }" @click="
          selecionarStatus(
            STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA
          )
          ">
          <span class="rotulo">
            Aguardando aprovação da reitoria
          </span>

          <strong>
            {{ resumo.aguardandoReitoria }}
          </strong>

          <small>
            Requerem uma decisão
          </small>
        </button>


        <button type="button" class="card-resumo aprovada" :class="{
          selecionado:
            filtros.status === STATUS_PARCERIA.PARCERIA_FORMALIZADA
        }" @click="
          selecionarStatus(
            STATUS_PARCERIA.PARCERIA_FORMALIZADA
          )
          ">
          <span class="rotulo">
            Formalizadas
          </span>


          <strong>
            {{ resumo.formalizadas }}
          </strong>
          <small>
            Solicitações aprovadas
          </small>
        </button>



        <button type="button" class="card-resumo reprovada" :class="{
          selecionado:
            filtros.status === STATUS_PARCERIA.REJEITADA
        }" @click="
        selecionarStatus(
          STATUS_PARCERIA.REJEITADA
        )
        ">
          <span class="rotulo">
            Indeferidas
          </span>
          <strong>
            {{ resumo.rejeitadas }}
          </strong>


          <small>
            Solicitações indeferidas
          </small>
        </button>
        <button type="button" class="card-resumo cancelada" :class="{
          selecionado:
            filtros.status === STATUS_PARCERIA.CANCELADA
        }" @click="
        selecionarStatus(
          STATUS_PARCERIA.CANCELADA
        )
        ">
          <span class="rotulo">
            Canceladas
          </span>

          <strong>
            {{ resumo.canceladas }}
          </strong>

          <small>
            Solicitações canceladas
          </small>
        </button>

      </div>

      <div class="painel-listagem">

        <div class="filtros">

          <div class="campo-busca">

            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>

            <input v-model="filtros.busca" type="search" placeholder="Buscar por título, ação ou coordenador"
              aria-label="Buscar solicitações" @keyup.enter="aplicarFiltros" />

          </div>



          <select v-model="filtros.status" aria-label="Filtrar por status" @change="aplicarFiltros">
            <option value="">Todos os status</option>

            <option :value="STATUS_PARCERIA.FORMULARIO_RECEBIDO">
              Aguardando análise
            </option>

            <option :value="STATUS_PARCERIA.EM_ANALISE">
              Em análise
            </option>

            <option :value="STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO">
              Em articulação
            </option>

            <option :value="STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA">
              Aguardando aprovação da reitoria
            </option>

            <option :value="STATUS_PARCERIA.PARCERIA_FORMALIZADA">
              Formalizadas
            </option>

            <option :value="STATUS_PARCERIA.REJEITADA">
              Indeferidas
            </option>

            <option :value="STATUS_PARCERIA.CANCELADA">
              Canceladas
            </option>
          </select>



          <button type="button" class="btn-filtrar" @click="aplicarFiltros">
            Buscar
          </button>

        </div>

        <div v-if="carregando" class="estado-lista">
          <span class="spinner" aria-hidden="true"></span>

          <p>
            Carregando solicitações...
          </p>
        </div>

        <div v-else-if="erro" class="estado-lista erro-lista">
          <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>

          <p>
            {{ erro }}
          </p>

          <button type="button" @click="carregarDados">
            Tentar novamente
          </button>
        </div>



        <div v-else-if="parcerias.length === 0" class="estado-lista">
          <i class="fa-regular fa-folder-open" aria-hidden="true"></i>

          <p>
            Nenhuma solicitação encontrada para os filtros selecionados.
          </p>
        </div>

        <div v-else class="tabela-container">

          <table>

            <thead>
              <tr>
                <th>
                  Ação vinculada
                </th>

                <th>
                  Coordenador
                </th>
                <th>
                  Recebida em
                </th>
                <th>
                  Status
                </th>

                <th>
                  Analista responsável
                </th>

                <th>
                  <span class="sr-only">
                    Ações
                  </span>
                </th>
              </tr>
            </thead>


            <tbody>

              <tr v-for="parceria in parcerias" :key="parceria.id">

                <td>
                  {{
                    parceria.nomeAcao ||
                    parceria.instituicaoParceira ||
                    parceria.tituloAcao ||
                    parceria.titulo ||
                    "—"
                  }}
                </td>


                <td>

                  {{
                    parceria.nomeCoordenador ||
                    parceria.solicitante?.nome ||
                    "—"
                  }}

                  <small v-if="parceria.solicitante?.unidade">
                    {{ parceria.solicitante.unidade }}
                  </small>

                </td>


                <td>
                  {{ formatarData(parceria.dataSolicitacao) }}
                </td>


                <td>

                  <span class="status" :class="`status-${parceria.status?.toLowerCase()}`">
                    {{
                      STATUS_PARCERIA_LABEL_PREX[parceria.status] ||
                      parceria.status
                        ?.replaceAll('_', ' ')
                        .toLowerCase()
                        .replace(/(^|\s)\S/g, letra => letra.toUpperCase()) ||
                      "—"
                    }}
                  </span>


                </td>


                <td class="celula-analista">

                  <template v-if="obterNomeAnalista(parceria.id)">

                    <i class="fa-solid fa-user-check analista-icone" aria-hidden="true"></i>

                    {{ obterNomeAnalista(parceria.id) }}

                  </template>


                  <span v-else class="sem-analista">
                    <i>
                      Sem analista
                    </i>
                  </span>

                </td>

                <td class="celula-acoes">

                  <button type="button" class="btn-detalhes" @click="abrirDetalhes(parceria)">
                    Ver solicitação
                  </button>

                </td>

              </tr>

            </tbody>

          </table>

        </div>

        <footer v-if="!carregando && totalElementos > 0" class="paginacao">

          <span>
            Exibindo
            {{ inicioPagina }}–{{ fimPagina }}
            de
            {{ totalElementos }}
          </span>


          <div>

            <button type="button" :disabled="paginaAtual === 0" aria-label="Página anterior" @click="
              mudarPagina(
                paginaAtual - 1
              )
              ">
              ‹
            </button>


            <span>
              Página
              {{ paginaAtual + 1 }}
              de
              {{ totalPaginas }}
            </span>


            <button type="button" :disabled="paginaAtual >= totalPaginas - 1
              " aria-label="Próxima página" @click="
                mudarPagina(
                  paginaAtual + 1
                )
                ">
              ›
            </button>

          </div>

        </footer>

      </div>

    </div>

  </section>
</template>


<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import GerenciadorParceriasAcaoModal from "@/components/parcerias/GerenciadorParceriasAcaoModal.vue";

const modalGerenciadorAberto = ref(false);

function abrirGerenciadorAcoes() {
  modalGerenciadorAberto.value = true;
}

function fecharGerenciadorAcoes() {
  modalGerenciadorAberto.value = false;
}

import { useParceriasPrex } from "@/composables/useParceriasPrex";

import {
  STATUS_PARCERIA_LABEL_PREX,
} from "@/constants/parcerias";

import { formatarData } from "@/utils/FormatarEntradas";


const router = useRouter();


const {
  parcerias,
  resumo,
  filtros,

  paginaAtual,
  totalPaginas,
  totalElementos,

  carregando,
  erro,

  avaliacoesPorParceria,

  inicioPagina,
  fimPagina,

  carregarDados,
  aplicarFiltros,
  selecionarStatus,
  mudarPagina,

  STATUS_PARCERIA,
} = useParceriasPrex({
  tamanhoPagina: 8,
});



const feedback = reactive({
  texto: "",
  tipo: "sucesso",
});


function obterNomeAnalista(id) {
  const avaliacoes =
    avaliacoesPorParceria.value[id] || [];

  const analise = avaliacoes.find(
    (avaliacao) =>
      avaliacao.decisaoTomada ===
      STATUS_PARCERIA.EM_ANALISE
  );

  return analise
    ? analise.nomeAvaliador
    : null;
}



function abrirDetalhes(parceria) {
  if (!parceria?.id) {
    console.error(
      "Não foi possível abrir os detalhes: ID da parceria não encontrado.",
      parceria
    );

    return;
  }

  router.push({
    name: "parceria-prex-view",

    params: {
      parceriaId: parceria.id,
    },
  });
}


onMounted(() => {
  carregarDados();
});

function limparFeedback() {
  feedback.texto = "";
}
</script>

<style scoped>
.dashboard-parcerias {
  width: 100%;
  color: var(--roxo-escuro);
}

.dashboard-header,
.filtros,
.paginacao,
.paginacao>div {
  display: flex;
  align-items: center;
}

.dashboard-header {
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.dashboard-header h2 {
  margin: 0;
  color: var(--parcerias-titulo-cor, var(--roxo-primario));
  font-size: 1.5rem;
  font-weight: 700;
}

.dashboard-header p {
  margin: 6px 0 0;
  color: var(--parcerias-subtitulo-cor, var(--cinza-medio));
  font-size: 0.9rem;
}

.btn-gerenciar-parcerias-acao {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border: 1px solid #0f172a;
  border-radius: 8px;
  background: #0f172a;
  color: #ffffff;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.1);
  flex-shrink: 0;
}

.btn-gerenciar-parcerias-acao:hover {
  background: #1e293b;
  border-color: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15);
}

.feedback {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 12px 15px;
  border-radius: 10px;
  font-size: 0.84rem;
}

.feedback.sucesso {
  color: var(--verde-escuro);
  background: var(--verde-claro);
}

.feedback.erro {
  color: var(--vermelho-escuro);
  background: var(--vermelho-claro);
}

.feedback button {
  border: 0;
  color: inherit;
  background: transparent;
  font-size: 1.25rem;
  cursor: pointer;
}

.cards-resumo {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.card-resumo {
  position: relative;
  min-height: 130px;
  padding: 18px;
  overflow: hidden;
  border: 1px solid var(--roxo-superficie);
  border-radius: 14px;
  text-align: left;
  background: var(--branco);
  box-shadow: 0 5px 18px hsla(258, 55%, 15%, 0.06);
  cursor: pointer;
  transition:
    transform 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}

.card-resumo::after {
  position: absolute;
  right: -22px;
  bottom: -36px;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.15;
  content: "";
}

.card-resumo.total {
  color: var(--roxo-primario);
}

.card-resumo.pendente {
  color: var(--azul-claro);
}

.card-resumo.analise {
  color: var(--azul-escuro);
}

.card-resumo.aguardando-articulacao {
  color: var(--verde);
}

.card-resumo.aguardando-reitoria {
  color: var(--laranja-escuro);

}

.card-resumo.aprovada {
  color: var(--roxo-medio);
}

.card-resumo.reprovada {
  color: var(--vermelho);
}

.card-resumo.cancelada {
  color: var(--cinza-escuro);
}

.card-resumo:hover,
.card-resumo.selecionado {
  transform: translateY(-2px);
  border: 2px solid white;
  box-shadow: 0 8px 22px hsla(258, 55%, 15%, 0.1);
}

.card-resumo.total:hover,
.card-resumo.total.selecionado {
  background-color: var(--roxo-escuro);
  color: white;
}

.card-resumo.pendente:hover,
.card-resumo.pendente.selecionado {
  background-color: var(--azul-claro);
  color: white;
}

.card-resumo.analise:hover,
.card-resumo.analise.selecionado {
  background-color: var(--azul-escuro);
  color: white;
}

.card-resumo.aguardando-articulacao:hover,
.card-resumo.aguardando-articulacao.selecionado {
  background-color: var(--verde);
  color: white;

}

.card-resumo.aguardando-reitoria:hover,
.card-resumo.aguardando-reitoria.selecionado {
  background-color: var(--laranja-escuro);
  color: white;

}

.card-resumo.aprovada:hover,
.card-resumo.aprovada.selecionado {
  background-color: var(--roxo-medio);
  color: white;
}

.card-resumo.reprovada:hover,
.card-resumo.reprovada.selecionado {
  background-color: var(--vermelho);
  color: white;
}


.card-resumo.cancelada:hover,
.card-resumo.cancelada.selecionado {
  background-color: var(--cinza-escuro);
  color: white;
}

.card-resumo .rotulo,
.card-resumo small {
  display: block;
}

.card-resumo .rotulo {
  color: currentColor;
  font-size: 0.78rem;
  font-weight: 700;
}

.card-resumo strong {
  display: block;
  margin: 7px 0 1px;
  font-size: 2rem;
  line-height: 1;
}

.card-resumo small {
  color: currentColor;
  font-size: 0.7rem;
  opacity: 0.7;
}

.painel-listagem {
  overflow: hidden;
  border: 1px solid var(--roxo-superficie);
  border-radius: 15px;
  background: var(--branco);
  box-shadow: 0 6px 20px hsla(258, 55%, 15%, 0.06);
}

.filtros {
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid var(--roxo-superficie);
  background: var(--roxo-superficie);
}

.campo-busca {
  position: relative;
  flex: 1;
}

.campo-busca i {
  position: absolute;
  top: 50%;
  left: 14px;
  color: var(--cinza-medio);
  transform: translateY(-50%);
}

.campo-busca input,
.filtros select {
  width: 100%;
  min-height: 42px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 9px;
  color: var(--cinza-escuro);
  background: var(--branco);
  font-size: 0.82rem;
  outline: none;
}

.campo-busca input {
  padding: 9px 14px 9px 40px;
}

.filtros select {
  width: 185px;
  padding: 8px 12px;
}

.campo-busca input:focus,
.filtros select:focus {
  border-color: var(--roxo-claro);
  box-shadow: 0 0 0 3px hsla(258, 70%, 58%, 0.12);
}

.btn-filtrar {
  min-height: 42px;
  padding: 9px 17px;
  border: 1px solid var(--roxo-medio);
  border-radius: 9px;
  color: var(--branco);
  background: var(--roxo-medio);
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
}

.tabela-container {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
}

th {
  padding: 13px 16px;
  color: var(--cinza-medio);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: var(--roxo-superficie);
  font-size: 0.68rem;
}

td {
  max-width: 220px;
  padding: 15px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-escuro);
  vertical-align: middle;
}

tbody tr:hover {
  background: var(--roxo-superficie);
}

td small,
.celula-solicitacao span {
  display: block;
  margin-top: 3px;
  color: var(--cinza-medio);
  font-size: 0.67rem;
}

.celula-solicitacao strong {
  display: block;
  color: var(--roxo-escuro);
  font-size: 0.8rem;
  line-height: 1.35;
}

.celula-solicitacao span {
  margin: 0 0 4px;
  font-weight: 700;
}

.status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
}

/* Etapas iniciais */
.status-formulario_recebido {
  color: var(--branco);
  background: var(--azul-claro);
}


/* Em andamento */
.status-em_analise {
  color: var(--branco);
  background: var(--azul-escuro);
}

.status-aguardando_ajustes {
  color: #9a3412;
  background: #fff7ed;
  border-color: #fdba74;
}

.status-em_articulacao_e_formalizacao {
  color: var(--branco);
  background: var(--verde);
}

.status-aguardando_aprovacao_reitoria {
  color: var(--branco);
  background: var(--laranja-escuro);
}

/* Resultados positivos */
.status-parceria_formalizada {
  color: var(--branco);
  background: var(--roxo-medio);
}

/* Resultados negativos */
.status-rejeitada {
  color: var(--branco);
  background: var(--vermelho-escuro);
}

/* Cancelamento */
.status-cancelada {
  color: var(--branco);
  background: var(--cinza-escuro);
}


.celula-acoes {
  text-align: right;
}

.btn-detalhes {
  padding: 7px 11px;
  border-radius: 8px;
  color: var(--branco);
  background: var(--roxo-primario);
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.btn-detalhes:hover {
  background: var(--roxo-medio);
}

.estado-lista {
  display: flex;
  min-height: 260px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 30px;
  color: var(--cinza-medio);
  text-align: center;
}

.estado-lista i {
  color: var(--roxo-claro);
  font-size: 2rem;
}

.estado-lista p {
  margin: 0;
  font-size: 0.86rem;
}

.estado-lista button {
  padding: 8px 12px;
  border: 0;
  border-radius: 8px;
  color: var(--branco);
  background: var(--roxo-medio);
  cursor: pointer;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid var(--roxo-superficie);
  border-top-color: var(--roxo-medio);
  border-radius: 50%;
  animation: girar 0.8s linear infinite;
}

@keyframes girar {
  to {
    transform: rotate(360deg);
  }
}

.paginacao {
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-medio);
  font-size: 0.73rem;
}

.paginacao>div {
  gap: 9px;
}

.paginacao button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 8px;
  color: var(--roxo-medio);
  background: var(--branco);
  font-size: 1.1rem;
  cursor: pointer;
}

.paginacao button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.decisao-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: hsla(258, 55%, 15%, 0.6);
  backdrop-filter: blur(3px);
}

.modal-decisao {
  width: min(480px, 100%);
  padding: 32px;
  border-radius: 18px;
  background: var(--branco);
  box-shadow: 0 24px 80px hsla(258, 55%, 15%, 0.28);
  text-align: center;
}

.icone-decisao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  border-radius: 50%;
  font-size: 1.5rem;
}

.icone-decisao.aprovar {
  color: var(--verde);
  background: var(--verde-claro);
}

.icone-decisao.rejeitar {
  color: var(--vermelho);
  background: var(--vermelho-claro);
}

.modal-decisao h3 {
  margin: 0 0 6px;
  color: var(--roxo-escuro);
  font-size: 1.2rem;
}

.modal-decisao p {
  margin: 0 0 20px;
  color: var(--cinza-escuro);
  font-size: 0.9rem;
}

.modal-decisao label {
  display: block;
  margin-bottom: 18px;
  text-align: left;
  color: var(--roxo-primario);
  font-size: 0.82rem;
  font-weight: 700;
}

.modal-decisao label span {
  color: var(--vermelho);
}

.modal-decisao textarea {
  display: block;
  width: 100%;
  margin-top: 8px;
  padding: 10px 12px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 9px;
  color: var(--roxo-escuro);
  background: var(--branco);
  font-size: 0.84rem;
  font-family: inherit;
  resize: vertical;
  outline: none;
  box-sizing: border-box;
}

.modal-decisao textarea:focus {
  border-color: var(--roxo-claro);
  box-shadow: 0 0 0 3px hsla(258, 70%, 58%, 0.12);
}

.erro-decisao {
  margin: 0 0 14px;
  color: var(--vermelho-escuro);
  font-size: 0.82rem;
  text-align: left;
}

.acoes-decisao {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.acoes-decisao button {
  min-height: 40px;
  padding: 9px 18px;
  border-radius: 9px;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}

.btn-cancelar {
  border: 1px solid var(--roxo-superficie);
  color: var(--cinza-escuro);
  background: var(--branco);
}

.btn-confirmar.aprovar {
  border: 1px solid var(--roxo-medio);
  color: var(--branco);
  background: var(--roxo-medio);
}

.btn-confirmar.rejeitar {
  border: 1px solid var(--vermelho);
  color: var(--branco);
  background: var(--vermelho);
}

.btn-confirmar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1024px) {
  .cards-resumo {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filtros {
    flex-wrap: wrap;
  }

  .campo-busca {
    flex: 1 1 100%;
  }

  .filtros select {
    flex: 1 1 140px;
    width: auto;
  }

  .paginacao {
    flex-direction: column;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .cards-resumo {
    grid-template-columns: 1fr;
  }
}
</style>
